import { createTracker } from 'usage-tracker';
export const UsageTracker = createTracker({
  standalone: true,
  lastKnownEventProperties: ['screen']
});
export const trackEvent = (eventName, properties) => {
  UsageTracker.track('Forms AI Lib', eventName, properties);
};